import { NavbarHeightContext } from '@contexts/navbar-height'
import { CtaLink } from '@ui/cta-link'
import clsx from 'clsx'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React, {
  type FC,
  type ReactNode,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import useWindowScroll from 'react-use/lib/useWindowScroll'

type Props = {
  name: string
  asset: Queries.CardComparatorAssetFragment
  underCondition: ReactNode
  link: string
}

const CardHeader: FC<Props> = ({ asset, name, underCondition, link }) => {
  const { height: navbarHeight } = useContext(NavbarHeightContext)
  const [isSticky, setIsSticky] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  const { y } = useWindowScroll()

  useEffect(() => {
    if (ref.current) {
      const { top } = ref.current.getBoundingClientRect()
      setIsSticky(Math.ceil(top) <= Math.ceil(navbarHeight))
    }
  }, [y, navbarHeight])

  return (
    <div
      ref={ref}
      className={clsx(
        'flex',
        'flex-col',
        'items-center',
        'bg-white-50',
        'px-[0.5rem]',
        'tablet:px-[0.125rem]',
        'laptopL:px-[2.5rem]',
        isSticky ? 'py-[1.25rem]' : 'py-[1.5rem]',
        isSticky && 'shadow-[0_0_0_4px_white,0_6px_4px_rgba(0,0,0,0.1)]'
      )}
    >
      <GatsbyImage
        alt={asset.description}
        image={getImage(asset)}
        className={clsx(
          'mb-4 w-[100px] overflow-hidden rounded-[3px]',
          isSticky ? '!flex' : '!hidden'
        )}
      />
      <h3 className="mb-3 text-balance text-center text-110">{name}</h3>
      <p
        className={clsx(
          'text-center',
          'text-085',
          'mb-3',
          'min-h-[65px]',
          isSticky && 'hidden'
        )}
      >
        {underCondition}
      </p>
      <CtaLink href={link}>En savoir plus sur la carte</CtaLink>
    </div>
  )
}

export default CardHeader
